import React, { Component } from 'react';
import AnimatedWrapper from '../core/animated-wrapper';
import LineChartOvertime from './charts/line-chart-overtime';
import BarChartOvertimeStats from './charts/bar-chart-overtime';
import WeeklyBarChartOvertimeStats from './charts/weekly-bar-chart-overtime';
import MultiStackedBarChartTagsAvailableArticlesStats from './charts/multi-stacked-bar-chart-tags-available-fb-articles';
import BarChartInfluencersStats from './charts/bar-chart-influencers';
import AdminStatsService from '../../services/admin-stats/admin-stats';
import InstagramTotals from './instagram-totals';

import './admin-stats.css';
import { Tabs } from '../common/tabs/Tabs';
import { Tab } from '../common/tabs/Tab';

class AdminStatsPage extends Component {
  render() {
    return (
      <section className='regular-page admin-stats-container' style={{width: '800px',paddingLeft: '50px'}}>
        <h3 className='page-title'>Admin Statistics</h3>
        <hr className='title-separator' />

        {/* <LineChartOvertime metricPrefix='fb_post' days={7} /> */}

        <Tabs>
          <Tab title='Twitter & Insta'>
            {/* <InstagramTotals /> */}

            <h4 className='page-title'>Followed Me Back Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_folllowed_me_back' tags={false} days={8}/>

            <h4 className='page-title'>Followed Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_folllowed' tags={false} days={8}/>

            <h4 className='page-title'>Likeed Me Back Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_likeed_me_back' tags={false} days={8}/>

            <h4 className='page-title'>Likeed Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_likeed' tags={false} days={8}/>

            <h4 className='page-title'>Unfollowed Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_unfolllowed' tags={false} days={8}/>

            <h4 className='page-title'>tLikes @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_tried_like_posts' tags={false} days={8}/>

            <h4 className='page-title'>Likes @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_profile_monitor_likes_count' tags={false} days={8}/>

            <h4 className='page-title'>Comments @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_profile_monitor_comments_count' tags={false} days={8}/>

            <h4 className='page-title'>Followers @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_profile_monitor_followers_count' tags={false} days={8}/>

            <h4 className='page-title'>Following @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_profile_monitor_following_count' tags={false} days={8}/>

            <h4 className='page-title'>Found Users @ Instagram</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_found' tags={false} days={8}/>

            <h4 className='page-title'>Found Users @ Twitter</h4>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_candidates_found' tags={false} days={8}/>
          </Tab>

          <Tab title='Influencers Distribution'>
            {/* <InstagramTotals /> */}

            <h3 className='page-title'>Today (%)</h3>
            <hr className='title-separator' />
            <BarChartInfluencersStats beforeXDays={0} untilXDays={0} />

            <h3 className='page-title'>Last 3 days (not inc today) (%)</h3>
            <hr className='title-separator' />
            <BarChartInfluencersStats beforeXDays={3} untilXDays={1} />

            <h3 className='page-title'>Last 7 days (%)</h3>
            <hr className='title-separator' />
            <BarChartInfluencersStats beforeXDays={7} untilXDays={1} />

            <h3 className='page-title'>Last 365 days (%)</h3>
            <hr className='title-separator' />
            <BarChartInfluencersStats beforeXDays={365} untilXDays={1} />
          </Tab>

          <Tab title='In Depth Twitter & Insta'>
            {/* <InstagramTotals /> */}

            <h3 className='page-title'>Total Found Users @ Instagram</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_found' tags={false} />

            <h3 className='page-title'>Total Followed Users @ Instagram</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='ins_candidates_folllowed' tags={false} />


            <h3 className='page-title'>Total Found Users @ Twitter</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_candidates_found' tags={false} />

            <h3 className='page-title'>Total Messaged Users</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_messaging' tags={false} />

            <h3 className='page-title'>Total Approved Candidates</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_candidates_approved' tags={false} />


            <h3 className='page-title'>Weekly Found Candidates</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_ins_candidates_found' />

            <h3 className='page-title'>Weekly Messaged Users</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_ins_messaging' />

            <h3 className='page-title'>Weekly Approved Candidates</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_ins_candidates_approved' />


            <h3 className='page-title'>Approved Candidates</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_candidates_approved' />

            <h3 className='page-title'>Messaged Users</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_messaging' />

            <h3 className='page-title'>Found Candidates</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_ins_candidates_found' />
          </Tab>

          <Tab title='Post'>
            <h3 className='page-title'>Facebook posts</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='fb_post' />

            <h3 className='page-title'>Twitter tweets</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_tweet' />

            <h3 className='page-title'>Twitter retweets</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_retweet' />
          </Tab>

          <Tab title='Available articles'>
            <h3 className='page-title'>Facebook available to post</h3>
            <hr className='title-separator' />
            <MultiStackedBarChartTagsAvailableArticlesStats getArticles={ AdminStatsService.getAvailablePostArticles } />

            <h3 className='page-title'>Twitter available to tweet</h3>
            <hr className='title-separator' />
            <MultiStackedBarChartTagsAvailableArticlesStats getArticles={ AdminStatsService.getAvailableTweetArticles } />
          </Tab>

          <Tab title='Followers change'>
            <h3 className='page-title'>Facebook followers change</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='fb_followers_change' />

            <h3 className='page-title'>Twitter followers change</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_followers_change' />
          </Tab>

          <Tab title='Weekly FC'>
            <h3 className='page-title'>Facebook followers change 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='fb_followers_change' />

            <h3 className='page-title'>Twitter followers change 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_followers_change' />
          </Tab>

          <Tab title='Weekly post'>
            <h3 className='page-title'>Facebook posts 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='fb_post' />

            <h3 className='page-title'>Twitter tweets 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_tweet' />

            <h3 className='page-title'>Twitter retweets 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='tw_retweet' />
          </Tab>

          <Tab title='Total Followers'>
            <h3 className='page-title'>Facebook followers</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='fb_followers' />

            <h3 className='page-title'>Twitter followers</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='tw_followers' />

            <h3 className='page-title'>Facebook likes</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='fb_likes' />
          </Tab>

          <Tab title='Likes'>
            <h3 className='page-title'>Facebook likes change</h3>
            <hr className='title-separator' />
            <BarChartOvertimeStats metricPrefix='fb_likes_change' />  

            <h3 className='page-title'>Facebook likes change 7 Days</h3>
            <hr className='title-separator' />
            <WeeklyBarChartOvertimeStats metricPrefix='fb_likes_change' />
          </Tab>
        </Tabs>          
      </section>
    );
  }
}

const WrappedAdminStatsPage = AnimatedWrapper(AdminStatsPage);
export default WrappedAdminStatsPage;